import correctVersionFileType from "../utils/helpers/correctVersionFileType";
import getCorrectFileType from "../utils/helpers/getCorrectFileType";
import { buildManagePageQueryString } from "./helpers/buildManagePageQueryString";
import { jumboMediaAPI } from "./service";

/**
 * Versions (Project Files) manage page API
*/

export const versionAPI = jumboMediaAPI.injectEndpoints({
    endpoints: (build) => ({
        getVersions: build.query({
            query: ({ columns, page, searchTerm, limit, orderColumnIndex, isDescSortDir }) => ({
                url: `/api/ProjectFiles/DataTablesSource${buildManagePageQueryString(columns, page, searchTerm, (page - 1) * limit, limit, orderColumnIndex, isDescSortDir)}`,
                responseHandler: res => res.json().then(res => ({ ...res, data: res.data.map(correctVersionFileType) })),
            }),
            providesTags: ['Versions'],
        }),
        createVersion: build.mutation({
            query: (body) => ({
                url: '/api/ProjectFiles/AdminPost',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Versions'],
        }),
        updateVersion: build.mutation({
            query: (body) => {
                return {
                    url: `/api/ProjectFiles/AdminPut/${body.Id}`,
                    method: 'PUT',
                    body,
                }
            },
            invalidatesTags: ['Versions'],
        }),
        deleteVersion: build.mutation({
            query: (body) => ({
                url: `/api/ProjectFiles/AdminDelete/${body.id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Versions'],
        }),
        setS3UploadError: build.mutation({
            query: ({projectId, filename, reason}) => ({
              url: `/api/Projects/SetFileUploadError?projectId=${projectId}&filename=${filename}&reason=${reason}`,
              method: 'POST',
            }),
          }),
    }),
})

export const {
    useGetVersionsQuery,
    useCreateVersionMutation,
    useUpdateVersionMutation,
    useDeleteVersionMutation,
    useSetS3UploadErrorMutation,
} = versionAPI;
